export const APP_VERSION = "0.25.0";
export const APP_VERSION_DATE = "2026-11-04";
export const APP_VERSION_NAME = "Finance: Capital Contributions";
